import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import { Modal, Box, Grid, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import initialValues from '../../validation/track-claim-escalation/initialValues';
import validationSchema from '../../validation/track-claim-escalation/validationSchema';
import formModel from '../../validation/track-claim-escalation/formModel';
import InputField from './form-fields/InputField';
import SelectField from './form-fields/SelectField';
import WebsiteForms from './WebsiteForms';

const ModalBox = styled(Box)(({ theme }) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    maxWidth: '600px',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4),
    borderRadius: theme.shape.borderRadius,
    position: 'relative', 
}));

const CloseButton = styled(IconButton)(({ theme }) => ({
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
}));

const TrackClaimEscalationForm = ({ open, onClose, policyNum, claimNum, handler }) => {
    const {
        emailAddress,
        claimNumber,
        policyNumber,
        contactNumber,
        escalationNote,
        contactMethod,
        claimHandler,
    } = formModel;

    const [response, setResponse] = useState(undefined);

    // Update initialValues with policyNum and claimNum
    const updatedInitialValues = {
        ...initialValues,
        [policyNumber.name]: policyNum,
        [claimNumber.name]: claimNum,
        [claimHandler.name]: handler,
    };

    return (
        <Modal open={open} onClose={onClose}>
            <ModalBox>
                <CloseButton onClick={onClose}>
                    <CloseIcon />
                </CloseButton>
                <WebsiteForms
                    formUrl="api/trackclaim/escalate"
                    initialValues={updatedInitialValues}
                    validationSchema={validationSchema}
                    handleResponse={(response) => setResponse(response)}
                >
                    <Typography variant="h1">Escalation Form</Typography>
                    <br />
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <InputField name={policyNumber.name} label={policyNumber.label} fullWidth disabled />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputField name={claimNumber.name} label={claimNumber.label} fullWidth disabled />
                        </Grid>
                        
                        <Grid item xs={12} sm={6}>
                            <InputField name={emailAddress.name} label={emailAddress.label} fullWidth />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputField name={contactNumber.name} label={contactNumber.label} fullWidth />
                        </Grid>
                        <Grid item xs={12}>
                            <InputField name={escalationNote.name} label={escalationNote.label} fullWidth 
                            multiline
                            rows={2}/>
                        </Grid>
                        <Grid item xs={12}>
                            <SelectField
                                name={contactMethod.name}
                                label={contactMethod.label}
                                options={[
                                    { value: 'Email', label: 'Email' },
                                    { value: 'Phone Call', label: 'Phone Call' },
                                    { value: 'Both', label: 'Both' },
                                ]}
                            />
                        </Grid>
                    </Grid>
                </WebsiteForms>
            </ModalBox>
        </Modal>
    );
};

export default TrackClaimEscalationForm;
